<template>
	<div class="service-locations-signature-card">
		<!-- RO Settings Section -->
		<SectionContainer>
			<!-- Appointment -->
			<template #left>
				<h4>Repair Order Invoice</h4>
			</template>
			<template #content>
				<!-- RO Default Advisor -->
				<dl>
					<dd>
						Signature Capture Message
					</dd>
					<dd>
						Signature Methods
					</dd>
				</dl>
			</template>
		</SectionContainer>
		<!-- Shared Settings Section -->
		<SectionContainer>
			<template #left>
				<h4>Work Order Authorization</h4>
			</template>
			<template #content>
				<dl>
					<dd>
						Signature Message
					</dd>
					<dd>
						Signature Methods
					</dd>
				</dl>
			</template>
		</SectionContainer>
	</div>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';

export default {
	name: 'ServiceLocationsSignatureCard',
	components: { SectionContainer }
};
</script>

<style lang="scss" scoped>
.service-locations-signature-card {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 12px;

	&__item {
		display: block;
	}

	.section-header {
		display: inline-block;
	}
}
</style>
